import { useNavigate } from 'react-router-dom';

export default function Footer() {
  const navigate = useNavigate();
  const cols = [
    { title: 'Explore',  links: [['Browse All', '/browse'], ['Rentals', '/browse?type=rent'], ['Auctions', '/browse?type=auction'], ['For Sale', '/browse?type=sale'], ['Categories', '/categories']] },
    { title: 'Sellers',  links: [['List an item', '/list'], ['How it Works', '/how-it-works'], ['Pricing & fees', '/fees'], ['Seller guide', '/seller-guide'], ['Payouts', '/dashboard/payouts']] },
    { title: 'Company',  links: [['About us', '/about'], ['Trust & Safety', '/trust'], ['Help centre', '/help'], ['Terms of service', '/terms'], ['Privacy policy', '/privacy']] },
  ];

  return (
    <footer style={{ background: '#2C2C2C', padding: '48px 48px 24px' }}>
      <div className="container" style={{ maxWidth: 1280 }}>
        <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr', gap: 52, paddingBottom: 32, borderBottom: '1px solid #3a3a3a', marginBottom: 24 }}>
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12, cursor: 'pointer' }} onClick={() => navigate('/')}>
              <span style={{ fontSize: 22 }}>🍒</span>
              <span style={{ fontFamily: "'Playfair Display',serif", fontWeight: 700, fontSize: 20 }}>
                <span style={{ color: '#C0392B' }}>cherry</span><span style={{ color: 'white' }}>pkd</span>
              </span>
            </div>
            <p style={{ fontSize: 13, color: '#666', lineHeight: 1.7, maxWidth: 240, marginBottom: 16 }}>
              Rent it. Bid on it. Buy it. The marketplace built on trust, powered by community.
            </p>
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
              {['💳 Card', '🪙 Crypto', '🔒 Escrow', '📦 EasyPost'].map(b => (
                <div key={b} style={{ padding: '4px 9px', background: 'rgba(255,255,255,.06)', borderRadius: 6, fontSize: 11, fontWeight: 600, color: '#888' }}>{b}</div>
              ))}
            </div>
          </div>
          {cols.map(col => (
            <div key={col.title}>
              <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: '2.5px', textTransform: 'uppercase', color: '#555', marginBottom: 14 }}>{col.title}</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 9 }}>
                {col.links.map(([label, path]) => (
                  <span key={path} onClick={() => navigate(path)}
                    style={{ fontSize: 13, color: '#777', cursor: 'pointer', transition: 'color .2s' }}
                    onMouseEnter={e => e.target.style.color = 'white'}
                    onMouseLeave={e => e.target.style.color = '#777'}
                  >{label}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontSize: 12, color: '#555', flexWrap: 'wrap', gap: 10 }}>
          <span>© 2025 Cherrypkd. All rights reserved.</span>
          <div style={{ display: 'flex', gap: 20 }}>
            {[['Privacy', '/privacy'], ['Terms', '/terms'], ['Cookies', '/cookies'], ['Sitemap', '/sitemap']].map(([l, p]) => (
              <span key={p} onClick={() => navigate(p)} style={{ cursor: 'pointer', transition: 'color .2s' }}
                onMouseEnter={e => e.target.style.color = 'white'}
                onMouseLeave={e => e.target.style.color = '#555'}
              >{l}</span>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
